export enum OrderServiceType {
  BOX = 'BOX',
}
